import React from 'react';
import { AritoIcon, AritoFormV2, BottomActionBarV2, DialogV2, HeaderTabsV2 } from '@/components/custom/erp';
import { initialSearchValues, SearchFormValues, searchSchema } from '../../schemas';
import { useSearchField } from '../../hooks';
import BasicInfoTab from './BasicInfoTab';
import FilterTab from './FilterTab';
import DetailTab from './DetailTab';

interface SearchDialogProps {
  open: boolean;
  onClose: () => void;
  onSearch: (filters: SearchFormValues) => void;
}

const SearchDialog = ({ open, onClose, onSearch }: SearchDialogProps) => {
  const searchFields = useSearchField();

  const handleSubmit = (data: SearchFormValues) => {
    onSearch({
      ...data,
      ma_kh: searchFields?.state.khachHang?.uuid,
      ma_vt: searchFields?.state.vatTu?.uuid,
      ma_kho: searchFields?.state.khoHang?.uuid,
      ma_lo: searchFields?.state.lo?.uuid,
      ma_vi_tri: searchFields?.state.viTri?.uuid,
      ma_unit: searchFields?.state.donViCoSo?.uuid
    });
    onClose();
  };

  return (
    <DialogV2
      open={open}
      onClose={onClose}
      title='Lọc phiếu nhập kho'
      maxWidth='lg'
      disableBackdropClose={false}
      disableEscapeKeyDown={true}
      titleIcon={<AritoIcon icon={12} />}
    >
      <AritoFormV2
        mode='add'
        hasAritoActionBar={false}
        schema={searchSchema}
        initialData={initialSearchValues}
        onSubmit={handleSubmit}
        className='w-[800px]'
        headerFields={
          <div className='max-h-[calc(100vh-150px)] overflow-y-auto'>
            <BasicInfoTab formMode='add' searchFieldStates={searchFields} />

            <HeaderTabsV2
              tabs={[
                {
                  id: 'detail',
                  label: 'Chi tiết',
                  component: <DetailTab formMode='add' searchFieldStates={searchFields} />
                }
              ]}
              className='border-b border-b-gray-200'
            />

            <FilterTab formMode='add' searchFieldStates={searchFields} />
          </div>
        }
        bottomBar={<BottomActionBarV2 onClose={onClose} mode='search' />}
      />
    </DialogV2>
  );
};

export default SearchDialog;
